import { Typography } from '@mui/material';
import UPButton from 'components/button';
import { DashboardContractsGraphProps } from 'modules/dashboard/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CONTRACTS__NEW_CONTRACT, DASHBOARD__TOTAL_CONTRACTS, MENU__CONTRACTS } from 'translations/constants';
import ContractsGraph from './ContractsGraph';
import { buildContractsGraphData } from './contractsGraphData';
import { ContractsGraphSection, GraphButtonContainer, GraphDisplayContainer, GraphTitle } from './styles';

const DashboardContractsGraph = (props: DashboardContractsGraphProps) => {
  const { openAddNewContractModal, contractsNumber, isEmployee } = props;

  const [t] = useTranslation();

  const { data: graphData, maxValue } = useMemo(
    () =>
      buildContractsGraphData(
        (contractsNumber ?? []).map(item => ({
          name: `Week ${item.week}`,
          value: item.count,
        })),
      ),
    [contractsNumber],
  );

  return (
    <ContractsGraphSection>
      <GraphTitle>
        <Typography>{t(MENU__CONTRACTS)}</Typography>
        <Typography>{t(DASHBOARD__TOTAL_CONTRACTS)}</Typography>
      </GraphTitle>
      <GraphDisplayContainer>
        {graphData.length > 0 && <ContractsGraph data={graphData} maxValue={maxValue} />}
      </GraphDisplayContainer>
      {!isEmployee && (
        <GraphButtonContainer>
          <UPButton
            text={t(CONTRACTS__NEW_CONTRACT)}
            onClick={openAddNewContractModal}
            gtmEvent="dashboard-add-new-contract"
            id="dashboard-add-new-contract-button"
          />
        </GraphButtonContainer>
      )}
    </ContractsGraphSection>
  );
};

export default DashboardContractsGraph;
